import { useState, useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import {
  getAllCuentas,
  getEducationColony,
  getEducationDegree,
  getSelectCity,
  getSimAsignadas,
  getSimAsignadasById,
} from '../../../service/dashboard/Dashboard';
import { CuentaModel } from '../../operacion/cuentas/models/CuentaModel';
import { SimpleAlert } from '../../../../_mexablock/helpers';

export const useSelectCuentas = (realoadGrid: number) => {
  const [data, setData] = useState<CuentaModel[]>([]);
  const [count, setCount] = useState(1);
  const [loadingRequest, setLoadingRequest] = useState(0);
  const history = useHistory();
  useEffect(() => {
    const fetchPost = async () => {
      setLoadingRequest(0);
      const res = await getAllCuentas()
        .then()
        .catch((error) => {
          history.push('/error/500');
        });
      if (res) {
        setData(res.rows);
        setCount(res.count);
        setLoadingRequest(1);
      }
    };
    if (realoadGrid) {
      fetchPost();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [realoadGrid]);
  return { data, count, loadingRequest };
};

export const useEducationDegree = (show: boolean, filter: any) => {
  const [data, setData] = useState<any[]>([]);
  const filterRef = useRef<string>();

  useEffect(() => {
    const filterString = JSON.stringify(filter);

    if (filterRef.current === filterString) return;
    filterRef.current = filterString;

    const fetchPost = async () => {
      const res = await getEducationDegree(filter)
        .then()
        .catch((error) => {
          let resMessageToast: string = '';
          const {
            data: { message },
          } = error.response;
          resMessageToast = `${message}`;
          SimpleAlert(resMessageToast, 3000, 'error');
        });
      if (res) {
        setData(res);
      }
    };
    if (show) {
      fetchPost();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show, JSON.stringify(filter)]);
  return { data };
};

export const useEducationColony = (show: boolean, filter: any) => {
  const [data, setData] = useState<any[]>([]);
  const filterRef = useRef<string>();

  useEffect(() => {
    const filterString = JSON.stringify(filter);

    if (filterRef.current === filterString) return;
    filterRef.current = filterString;

    const fetchPost = async () => {
      const res = await getEducationColony(filter)
        .then()
        .catch((error) => {
          let resMessageToast: string = '';
          const {
            data: { message },
          } = error.response;
          resMessageToast = `${message}`;
          SimpleAlert(resMessageToast, 3000, 'error');
        });
      if (res) {
        setData(res);
      }
    };
    if (show) {
      fetchPost();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show, JSON.stringify(filter)]);
  return { data };
};

export const useSelectCity = (show: boolean) => {
  const [data, setData] = useState<any[]>([]);
  useEffect(() => {
    const fetchPost = async () => {
      const res = await getSelectCity()
        .then()
        .catch((error) => {
          let resMessageToast: string = '';
          const {
            data: { message },
          } = error.response;
          resMessageToast = `${message}`;
          SimpleAlert(resMessageToast, 3000, 'error');
        });
      if (res) {
        setData(res);
      }
    };
    if (show) {
      fetchPost();
    }
  }, [show]);
  return { data };
};

export const useSimasignadas = (show: boolean, filter: any) => {
  const [data, setData] = useState<any[]>(() => {
    const saved = sessionStorage.getItem('simasignadas');
    return saved ? JSON.parse(saved) : [];
  });
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const fetchPost = async () => {
      try {
        const res = await getSimAsignadas(filter);
        if (res) {
          setData(res);
          sessionStorage.setItem('simasignadas', JSON.stringify(res));
        }
      } catch (error: any) {
        const message =
          error?.response?.data?.message ?? 'Error al obtener datos';
        SimpleAlert(message, 3000, 'error');
      } finally {
        setLoading(false);
      }
    };

    if (show) {
      fetchPost();
    } else {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show, filter]);

  return { data, loading };
};

interface zonaInfo {
  zona_id: number;
  zona_nombre: string;
  cantidad_stocks: number;
  totalAsignadas: number;
  totalPortadas: number;
  totalActivadas: number;
}
export const useInfoZona = (show: boolean, filter: number, date: any) => {
  const [data, setData] = useState<zonaInfo | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchPost = async () => {
      setLoading(true);
      try {
        const res = await getSimAsignadasById(filter, date);
        if (res) {
          setData({ ...res });
          setError(null);
        }
      } catch (error: any) {
        const message =
          error?.response?.data?.message ?? 'Error al obtener datos';
        SimpleAlert(message, 3000, 'error');
        setError(message);
      } finally {
        setLoading(false);
      }
    };

    if (show) fetchPost();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show, filter, date]);

  return { data, loading, error };
};
